module.exports = __webpack_public_path__ + "images/c20a116b04c79c22aa694b07d24f54af.png";